const actionTypes = {
  SET_DIRECT_CORP_DETAIL: 'setDirectCorpDetail',
  SET_PARAMS: 'setDirectlCorpParams',
  SET_TOTAL_COUNT: 'setDirectCorpTotalCount',
}
export default actionTypes
